"use strict";

var _slicedToArray = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var LocalContext =
/*#__PURE__*/
function () {
  function LocalContext(binding) {
    _classCallCheck(this, LocalContext);

    this.m_Binding = binding;
  }

  _createClass(LocalContext, [{
    key: "Resolve",
    value: function Resolve(dsl) {
      this.m_Code.body.directives = [];
      this.m_Code.body.body = dsl.Transcribe(this.ToStatements(), this.m_Path);
    }
  }, {
    key: "ToStatements",
    value: function ToStatements() {
      return this.m_Code.body.body;
    }
  }, {
    key: "GetDSLName",
    value: function GetDSLName() {
      var _this$m_Code$body$dir = _slicedToArray(this.m_Code.body.directives, 1),
          directive = _this$m_Code$body$dir[0];

      if (directive) {
        var _directive$value$valu = directive.value.value.split(" "),
            _directive$value$valu2 = _slicedToArray(_directive$value$valu, 2),
            context_name = _directive$value$valu2[1];

        return context_name;
      }

      return "";
    }
  }, {
    key: "m_Path",
    get: function get() {
      return this.m_Binding.path;
    }
  }, {
    key: "m_Code",
    get: function get() {
      return this.m_Path.node;
    }
  }, {
    key: "m_Refs",
    get: function get() {
      return this.m_Binding.referencePaths;
    }
  }, {
    key: "m_Name",
    get: function get() {
      return this.m_Code.id.name;
    }
  }]);

  return LocalContext;
}();

exports.LocalContext = LocalContext;